/* eslint-disable simple-import-sort/imports */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Module */
import { LandingPagesModule } from './landing-pages.module';

/* Containers */
import * as landingPagesContainers from './containers';

/* Resolvers */
import { DynamicRouteDataService } from '@common/resolvers';

/* Guards */
import * as commonGuards from '@common/guards';

/* Routes */
export const ROUTES: Routes = [
    // {
    //     path: '',
    //     canActivate: [commonGuards.processQueryParams],
    //     component: landingPagesContainers.LandingPagesComponent,
    // },
    {
        path: 'overland-journal',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.OverlandJournalComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'waitlist',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.OverlandExpoWest2023Component,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'fb-waitlist',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.OverlandExpoWest2023Component,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'expo-west-2023',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.OverlandExpoWest2023Component,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'expo-west-2023-qr',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.OverlandExpoWest2023Component,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'clear-cache',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.ClearCacheComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'reset',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.ClearCacheComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'rally',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.RallyGameComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'instagram',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.SocialRedirectComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'youtube',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.SocialRedirectComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'facebook',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.SocialRedirectComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'x',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.SocialRedirectComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'threads',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.SocialRedirectComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: 'tiktok',
        canActivate: [commonGuards.processQueryParams],
        component: landingPagesContainers.SocialRedirectComponent,
        resolve: {
            dynamicRouteData: DynamicRouteDataService,
        },
    },
    {
        path: '**',
        pathMatch: 'full',
        loadChildren: () =>
            import('modules/error/error-routing.module').then((m) => m.ErrorRoutingModule),
    },
];

@NgModule({
    imports: [LandingPagesModule, RouterModule.forChild(ROUTES)],
    exports: [RouterModule],
})
export class LandingPagesRoutingModule {}
